import { useContext } from 'react'
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import clsx from 'clsx'
import { StoreContext } from '../../store'
import * as reducers from '../../store/reducers'
import { compose } from 'react-recompose'
import StyledButtonBase, { classes } from './ContactUsButtonStyles'

const ContactUsButton = () => {
  const { dispatch, prospect } = useContext(StoreContext)
  const setOpenContactDialog = compose(dispatch, reducers.setContactDialogOpen)

  const handleContactUs = () => {
    if (!prospect) {
      dispatch(
        reducers.setBuyerAuthCallback(() => {
          setOpenContactDialog(true)
          dispatch(reducers.setBuyerAuthCallback())
        }),
        reducers.setBuyerLoginDialog({
          open: true,
          message: 'Thank you for your interest! Please sign-in to contact us.',
        })
      )
      return
    }

    setOpenContactDialog(true)
    dispatch(reducers.setBuyerAuthCallback()) // reset
  }

  return (
    <StyledButtonBase
      className={clsx(classes.btn, classes.contactUsBtn)}
      data-testid="contact_us_button"
      onClick={handleContactUs}
    >
      <Icon variant="contained" className={classes.root}>
        <ContactMailOutlinedIcon className={classes.icon} />
      </Icon>
      <Typography
        classes={{
          button: classes.contactUsBtnText,
        }}
        variant={'button'}
      >
        Contact Us
      </Typography>
    </StyledButtonBase>
  )
}

export default ContactUsButton
